<div class="layout">
  <div class="snack-container">
    <h1>{{ 'sweetsAndDrinks.title' | translate }}</h1>
    <div class="list">
      <div class="tile" *ngFor="let snack of sweetsAndDrinks">
        <mat-card class="snack-card">
          <img mat-card-image [src]="snack.img[0]" alt="Bild hier" fetchpriority="high">
          <div class="snack-details">
            <mat-card-title>{{ snack.name | translate }}</mat-card-title>
            <span class="price-fraction">
              <mat-card-subtitle>{{ snack.price }}</mat-card-subtitle>
              <mat-card-subtitle class="fraction">{{ snack.fraction }}</mat-card-subtitle>
              <span class="material-symbols-outlined price-icon">euro_symbol</span>
            </span>
            <p class="cleaning-fee">
              <span *ngIf="snack.cleaningFee; else noFee">
                {{ 'cleaningFee.part1' | translate }} {{ snack.cleaningFee }}€ {{ 'cleaningFee.part2' | translate }}
              </span>
              <ng-template #noFee>&nbsp;</ng-template>
            </p>
            <button mat-flat-button (click)="openDialog(snack)">{{ 'sweetsAndDrinks.moreImages' | translate }}</button>
            <mat-card-content>
              <div class="metric">
                <span class="material-symbols-outlined">straighten</span>
                {{ snack.size }}
                <small class="dimension-hint">{{ 'bounceCastle.dimensionsHint' | translate }}</small>
              </div>
              <div class="metric">
                <span class="material-symbols-outlined">weight</span>
                {{ snack.weight }}
              </div>
              <div class="metric">
                <span class="material-symbols-outlined">power</span>
                {{ snack.engine }}
              </div>
              <div class="metric">
                <span class="material-symbols-outlined">add_shopping_cart</span>
                <div class="extras-list">
                  <div class="extra" *ngFor="let extra of snack.extras">
                    <div class="extra-item">{{ extra.item | translate }}</div>
                    <div class="extra-price-container">
                      <div class="extra-price">{{ extra.price }}</div>
                      <span class="fraction">{{ extra.fraction }}</span>
                      <span class="material-symbols-outlined price-icon price-icon">euro_symbol</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="metric">
                <span class="material-symbols-outlined">family_star</span>
                {{ snack.features | translate }}
              </div>
            </mat-card-content>
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>